import routes from '@/router/routes';
import { resolveRouteRoles } from '@core/utils/roleAccess';

// Extract and transform routes into a simpler format
const transformRoutes = routes
  .filter(route => route.meta && route.meta.verticalMenu)
  .map(route => ({
    title: route.meta.verticalMenu.title,
    route: route.name,
    icon: route.meta.verticalMenu.icon,
    roles: resolveRouteRoles(route.meta),
    parent: route.meta.verticalMenu.parent,
    children: route.meta.verticalMenu.isGroup ? [] : null,
    isGroup: route.meta.verticalMenu.isGroup
  }));

const buildMenuStructure = items => {
  const verticalMenu = [...items.filter(i => !i.parent)];
  const childItems = items.filter(i => i.parent);

  childItems.forEach(child => {
    const parent = items.find(i => i.route === child.parent && i.isGroup);
    if (parent) {
      parent.children = parent.children || [];
      parent.children.push(child);
    } else {
      verticalMenu.push(child);
    }
  });

  return verticalMenu;
};

const verticalMenu = buildMenuStructure(transformRoutes);

export default verticalMenu;
